import _get from 'lodash/get';
import _keys from 'lodash/keys';
import _map from 'lodash/map';
import { KILOBYTE, MEGABYTE } from '../../utility/constants';
import { formatNumberDecimals } from './amountUtils';

/**
 * Griffin recommended setTitleCase method
 * https://github.paypal.com/pages/Globalization-R/griffin-paypal/docs/faq.html#how-can-i-generate-a-language-dropdown-for-a-country
 */
export function setTitleCase(str) {
  return str.replace(/(\S*)/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

// return if user is on mobile
export function isMobile() {
  const serverProps = document.getElementById('server-props');
  const serverPropsData = (serverProps && serverProps.innerHTML) || '{}';
  try {
    return _get(JSON.parse(serverPropsData), 'isMobile');
  } catch (err) {
    console.warn(err);
  }
  return false;
}

/**
 * Truncates text on after the desired number of characters and adds ellipsis at the end
 * @param {string} str - the string to truncate
 * @param {number} charNum - char index at which to start truncating text
 */
export function truncatesAtChar(str = '', charNum = 1) {
  const trunStr = str.substring(0, charNum).trim();

  return trunStr.concat('...');
}

export function getImageSize(fileSize, messages) {
  const size = fileSize > MEGABYTE ? fileSize / MEGABYTE : fileSize / KILOBYTE;
  const type = fileSize > MEGABYTE ? messages.megabyte : messages.kilobyte;

  return {
    size: formatNumberDecimals(size),
    type,
  };
}

/**
 * Fetch select options for language field based on the country selection
 */
export const getOptionsForLanguageField = (
  countryAndLanguageDetails,
  selectedCountry
) => {
  const countriesByCode = countryAndLanguageDetails.countriesByCode;

  selectedCountry = selectedCountry || 'US';

  const allLanguages = countriesByCode[selectedCountry].languages;
  const languageCodes = _keys(allLanguages);

  return _map(languageCodes, (languageCode) => {
    return {
      value: languageCode,
      displayValue: setTitleCase(allLanguages[languageCode].name),
    };
  });
};

/**
 * Substring equivalent of a string but takes in count the byte length
 */
export const byteSubstring = (string, start, stop) => {
  const enc = new TextEncoder();
  const dec = new TextDecoder('utf-8');
  const uint8 = enc.encode(string);
  const section = uint8.slice(start, stop);
  return dec.decode(section);
};
